export default "__VITE_ASSET__DS9_Ptan__"